// @module NVT.OutstandingPaymentAndEvent.OutstandingPaymentAndEvent
define('NVT.OutstandingPaymentAndEvent.OutstandingPaymentAndEvent.View'
	,	[
		'nvt_outstandingpaymentandevent_outstandingpaymentandevent.tpl'
	
		,	'NVT.OutstandingPaymentAndEvent.OutstandingPaymentAndEvent.SS2Model'
	
		,	'Backbone'
	
		,	'Profile.Model'
	
		]
	, function (
		nvt_outstandingpaymentandevent_outstandingpaymentandevent_tpl
	
		,	OutstandingPaymentAndEventSS2Model
	
		,	Backbone
	
		,	ProfileModel
	)
	{
		'use strict';
	
		// @class NVT.OutstandingPaymentAndEvent.OutstandingPaymentAndEvent.View @extends Backbone.View
		return Backbone.View.extend({
	
			template: nvt_outstandingpaymentandevent_outstandingpaymentandevent_tpl
	
		,	initialize: function (options) {
	
				this.options = options;
				this.container = options.container;
				this.layout = this.container.getComponent('Layout');
				this.pdp = this.container.getComponent('PDP');
				var self = this;
			}
	
		,	events: {
	
			}
	
		,	bindings: {
			
			}
	
		, 	childViews: {
	
			}
	
		,	getOutstandingPayment: function(param)
			{
				var self = this;
				self.getOutPayResponce = false;
	
					var model = new OutstandingPaymentAndEventSS2Model();
						model.fetch({async: false,data: {
						'param': '12345',
						'getmethod':'getOutstandingPayment'
					},
				}).done(function (response) {
					if(response.length > 0){
						self.getOutPayResponce = true;
					}
				});
			}
	
		,	dateOrd:function (d) {
			var self = this;
			if(d>3 && d<21) return d+'th';
			switch (d % 10) {
				case 1:  return d+"st";
				case 2:  return d+"nd";
				case 3:  return d+"rd";
				default: return d+"th";
			}
		}
		,	dateFormatConversion :function(paramdate)
			{
				var self = this;
				var parts = paramdate.split('/');
				let date = new Date(parts[2], parts[1] - 1, parts[0]);
				let weekday = new Intl.DateTimeFormat('en', { weekday: 'long' }).format(date);
				let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
				let month = new Intl.DateTimeFormat('en', { month: 'long' }).format(date);
				let day = new Intl.DateTimeFormat('en', { day: 'numeric' }).format(date);
				let newDateFormat = weekday+ ', ' +day +' ' +month +' '+year;
				return newDateFormat
			}
	
			//@method getContext @return NVT.OutstandingPaymentAndEvent.OutstandingPaymentAndEvent.View.Context
		,	getContext: function getContext()
			{
				var self = this;
				//@class NVT.OutstandingPaymentAndEvent.OutstandingPaymentAndEvent.View.Context
				if(self.options.pdp)
				{
					var profile = ProfileModel.getInstance();
					var isorgadmin = profile.get('roleidsbf');
	
					//var getresponce = self.getOutstandingPayment('');
						//self.getOutPayResponce == true ? true : false,
					var ems_emsebdate = self.options.pdp.item.custitem_nus_ems_emsebdate;
					var locationtype = self.options.pdp.item.custitem_nus_ems_locationtype;
					var eventetime = self.options.pdp.item.custitem_nus_eventetime ;
					var stime = self.options.pdp.item.custitem_event_stime ;
					var sdate =  self.options.pdp.item.custitem_nus_event_sdate;
					var edate =  self.options.pdp.item.custitem_nus_eventedate;
					if(edate)
					{
						edate = self.dateFormatConversion(edate);
					}
					if(sdate)
					{
						sdate = self.dateFormatConversion(sdate);
					}
				}
	
				return {
					//outstandingPayment : profile.get('isLoggedIn') === 'T',//isorgadmin && isoutstandingbalance,
					outstandingPayment :  profile.get('balance') > 0 ,
					isLoggedIn : profile.get('isLoggedIn') === 'T',
					ems_emsebdate :  ems_emsebdate || '' ,
					locationtype: locationtype || '',
					eventetime :  eventetime ? eventetime.toUpperCase() : '',
					stime : stime ? stime.toUpperCase() : '',
					sdate: sdate || '',
					edate: edate || '',
					getpriceLevel1 : self.options.pdp.item.pricelevel2_formatted || '' ,
					getpriceLevel2 : self.options.pdp.item.pricelevel3_formatted || '' ,
					getpriceLevel3 : self.options.pdp.item.pricelevel5_formatted || '' ,
					getpriceLevel4 : self.options.pdp.item.pricelevel12_formatted || '' ,
					dontshowprice :  self.options.pdp.item.dontshowprice === true,
					nopricemessage : self.options.pdp.item.nopricemessage
				,
				};
			}
		});
	});
	
